import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: 'transparent',
    justifyContent: 'flex-start',
    padding: 10,
    paddingRight: 0
  },
  showBorder: {
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
  },
  showText: {
    paddingHorizontal: 10,
    flex: 0.8,
  },
  currentSelection: {
    flex: 3,
    textAlign: 'center',
    paddingVertical: 9,
  },
  editButtonContainer: {
    flex: 0.1,
    paddingHorizontal: 10
  },
  editButtonContainerPymt:{
    flex: 0.4,
    paddingRight: 10
  },
  editButton: {
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  editButtonText: {
    paddingHorizontal: 10
  },
});

// SVG color
export const editButtonIconColor = PALETTE.primaryText;
